import { render, staticRenderFns } from "./_linkage.vue?vue&type=template&id=fd652d54&lang=pug"
import script from "./_linkage.vue?vue&type=script&lang=js"
export * from "./_linkage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports